import React from 'react';

export const Reports = () => {
  return (
    <div className='reports'>
      <h1>Reports</h1>
    </div>
  );
};

export const ReportsOne = () => {
  return (
    <div className='reports'>
      <h1>Reports/reports1</h1>
    </div>
  );
};

export const ReportsTwo = () => {
  return (
    <div className='reports'>
      <h1>Reports/reports2</h1>
    </div>
  );
};

export const ReportsThree = () => {
  return (
    <div className='reports'>
      <h1>Reports/reports3</h1>
    </div>
  );
};
